import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Loader2 } from 'lucide-react';
import { founderApi } from '@/lib/founderApi';
import { errMsg, formatPrice } from '@/lib/digitalApi';

const fieldCls = 'w-full bg-transparent border-b border-ivory/30 py-3 text-ivory placeholder:text-ivory/40 focus:outline-none focus:border-gold transition-colors';

const ComingSoon = () => (
  <div data-testid="fb-sales-coming-soon">
    <div className="inline-flex px-4 py-2 rounded-full border border-gold/60 text-gold text-[10px] font-label tracking-widest uppercase">Coming soon</div>
    <p className="mt-6 text-ivory/70 leading-relaxed text-[15px]">Purchases are not open yet. Join The Founder&rsquo;s List to hear the moment it becomes available.</p>
    <Link to="/founders-list" className="btn-ghost mt-6 !text-ivory" data-testid="fb-sales-founders-list-link">Join The Founder&rsquo;s List <ArrowRight size={14} strokeWidth={1.6} /></Link>
  </div>
);

export const BlueprintBuyPanel = ({ info, cancelled }) => {
  const [form, setForm] = useState({ first_name: '', email: '', website: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      window.location.href = (await founderApi.checkout(form)).checkout_url;
    } catch (err) { setError(errMsg(err)); setBusy(false); }
  };
  return (
    <div className="bg-matte text-ivory rounded-2xl p-8 lg:p-10 luxury-shadow" data-testid="fb-sales-buy-panel">
      <div className="eyebrow !text-gold">One-time purchase</div>
      <div className="mt-4 font-serif-display text-6xl" data-testid="fb-sales-price">{info ? formatPrice(info.price_cents, false) : '$39'}</div>
      <p className="mt-2 text-ivory/60 text-sm">One payment. No subscription. Includes your private workspace and PDF export.</p>
      {cancelled && <p className="mt-6 text-sm bg-ivory/10 rounded-xl px-5 py-4" data-testid="fb-sales-checkout-cancelled">Checkout was cancelled. You have not been charged.</p>}
      <div className="mt-8">
        {info?.sale_mode !== 'live' ? <ComingSoon /> : (
          <form onSubmit={submit} className="space-y-5" data-testid="fb-sales-buy-form">
            <input name="website" value={form.website} onChange={set('website')} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden />
            <input required maxLength={80} placeholder="First name" value={form.first_name} onChange={set('first_name')} className={fieldCls} data-testid="fb-sales-first-name" />
            <input required type="email" placeholder="your@email.com" value={form.email} onChange={set('email')} className={fieldCls} data-testid="fb-sales-email" />
            {error && <p className="text-red-300 text-sm" data-testid="fb-sales-error">{error}</p>}
            <button type="submit" disabled={busy} className="w-full inline-flex items-center justify-center gap-3 rounded-full bg-gold text-matte px-8 py-4 text-xs font-label tracking-widest uppercase hover:bg-ivory transition-colors duration-300 disabled:opacity-60" data-testid="fb-sales-buy-button">
              {busy && <Loader2 size={14} className="animate-spin" />} Get the Blueprint Builder · {formatPrice(info.price_cents, false)}
            </button>
            <p className="text-[11px] text-ivory/45 leading-relaxed">Secure checkout by Stripe. After payment, a private sign-in link to your Founder Workspace is sent to this email.</p>
          </form>
        )}
      </div>
    </div>
  );
};
